import React from 'react';

import { useGridApiContext, GridFilterItem } from '@mui/x-data-grid';

import AddCircleIcon from '@mui/icons-material/AddCircle';

import { Button } from 'components/Button';

import { ProtectorType } from 'core/constants';

import FilterItem from './components/FilterItem';

import { ContainerAddFilters, FilterMenuContainer, NoFilters } from './styles';
import { Filter } from './types';

const FilterMenu: React.FunctionComponent = () => {
  const context = useGridApiContext();
  const { lookup, orderedFields } = context.current.state.columns;

  const isPipeline = (field: string | null): boolean =>
    // @ts-ignore
    field != null && lookup[field]?.protectorType === ProtectorType.Pipeline;

  const firstFilterableColumn = Object.keys(lookup).find((key) => lookup[key].filterable && !isPipeline(key));

  const initialFilters = [
    {
      field: firstFilterableColumn || orderedFields[0],
      operator: 'contains',
      value: null,
    },
  ];

  const userItems = context.current.state.filter.filterModel.items.filter((item) => !isPipeline(item.field));

  const [filters, setFilters] = React.useState<Filter[]>(
    userItems.length === 0
      ? initialFilters
      : userItems.map(({ field, operator, value }) => ({ field, operator, value }))
  );

  const isInitialMount = React.useRef(true);

  React.useEffect(() => {
    if (isInitialMount.current) {
      isInitialMount.current = false;
      return;
    }

    const { filterModel } = context.current.state.filter;
    const pipelineItems = filterModel.items.filter((item) => isPipeline(item.field));

    context.current.setFilterModel({
      ...filterModel,
      items: [...pipelineItems, ...(filters as GridFilterItem[])],
    });
  }, [filters]);

  const addFilter = (): void => {
    setFilters([...filters, { field: null, operator: null, value: null }]);
  };

  const updateFilter = (index: number, data: Filter): void => {
    setFilters([...filters.slice(0, index), data, ...filters.slice(index + 1)]);
  };

  const deleteFilter = (index: number): void => {
    setFilters(filters.filter((value, i) => i !== index));
  };

  return (
    <FilterMenuContainer data-testid="grid-filter-panel">
      {filters.map((filter, index) => (
        <FilterItem
          columns={context.current.state.columns}
          filter={filter}
          key={`${filter.field}-${index}`}
          onChange={(data: Filter) => updateFilter(index, data)}
          onDelete={() => deleteFilter(index)}
        />
      ))}
      {!filters.length && <NoFilters>No filters applied</NoFilters>}
      <ContainerAddFilters>
        <Button onClick={addFilter} variant="text">
          <AddCircleIcon sx={{ marginRight: '8px' }} />
          Add Filter
        </Button>
      </ContainerAddFilters>
    </FilterMenuContainer>
  );
};

export default FilterMenu;
